<div class="details">
    <div class="extended-grabber" (mousemove)="onMouseMove($event)" (mousedown)="onMouseDown($event)">
    </div>
    <div class="grabber" (mousemove)="onMouseMove($event)" (mousedown)="onMouseDown($event)"></div>

    <button mat-icon-button style="float:right" (click)="sidenav.toggle()">
        <mat-icon matTooltip="Close">clear</mat-icon>
    </button>
    <p class="header" *ngIf="!detailsData.zoningCodeVersion?.ActualVersion else version">
        {{detailsData.zoningCode?.Name}}
    </p>

    <ng-template #version>
        <p class="header">{{detailsData.zoningCode?.Name}} v.{{detailsData.zoningCodeVersion?.ActualVersion}}</p>
    </ng-template>

    <mat-divider></mat-divider>

    <div class="tabs">
        <mat-tab-group class="mat-elevation-z0" mat-stretch-tabs="false" style="width: 100%;">
            <mat-tab label="Statistic">
                <app-zoning-code-version-statistic-tab [(isLoaded)]="isLoaded" [detailsData]="detailsData">
                </app-zoning-code-version-statistic-tab>
            </mat-tab>

            <mat-tab label="Data">
                <app-zoning-code-version-data-tab [detailsData]="detailsData" [attachmentType]="attachmentType">
                </app-zoning-code-version-data-tab>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>